/* @generated */

// src/assets/ui-icon/line/flag.tsx
import * as React from "react";
var FlagLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M13.508 7.37a.722.722 0 0 1-.785-.58A2.233 2.233 0 0 0 10.538 5H6v15h1.5v-6h3.04a.728.728 0 0 1 .71.585 2.217 2.217 0 0 0 2.395 1.779L18 15.988V6.983l-4.492.388Zm2.992 7.242-2.992.259a.725.725 0 0 1-.785-.58 2.232 2.232 0 0 0-2.184-1.791H7.5v-6h3.04a.728.728 0 0 1 .71.585 2.211 2.211 0 0 0 2.395 1.779l2.855-.247v5.995Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  FlagLine
};
